import { AppPrimaryButton } from "../../ui/buttons";
import { useResetPasswordContext } from "./ResetPasswordProvider";
import { ErrorSnackbar } from "../../snackbar";
import { useSnackbarContext } from "../../snackbar/SnackbarProvider";
import { useRouter } from "next/router";
import { useModalContext } from "../../modals";
import { putResetPassword } from "../../../../api/auth";
import { useGetCurrentPasswordStrength } from "../../../../hooks/auth";
import { PasswordStrength } from "../register/RegisterPasswordStrength/RegisterPasswordStrengthProvider";
import { ResetPasswordSuccessModal } from "../../modals/material/successResetModal";

export const ResetPasswordSubmitButton = () => {
  const { state, dispatch } = useResetPasswordContext();
  const { setSnackbar } = useSnackbarContext();
  const { query } = useRouter();
  const { showModal } = useModalContext();
  const passwordStrengthCriteria = useGetCurrentPasswordStrength({
    password: state.password,
  });

  const submitHandler = async () => {
    if (state.password !== state.confirmPassword) {
      dispatch({
        passwordError:
          "Passwords do not match. Please check both fields and ensure they are the same.",
      });

      return;
    }

    try {
      dispatch({
        isLoading: true,
      });

      await putResetPassword({
        password: state.password,
        token: query.token as string,
      });

      showModal(<ResetPasswordSuccessModal />);
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);

      console.error(error);
    } finally {
      dispatch({
        isLoading: false,
      });
    }
  };

  return (
    <AppPrimaryButton
      onClick={() => void submitHandler()}
      type={"submit"}
      className={"w-full"}
      disabled={
        state.isLoading ||
        state.password.length === 0 ||
        passwordStrengthCriteria <= PasswordStrength.WEAK
      }
    >
      Update Password
    </AppPrimaryButton>
  );
};
